import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Stack, Typography, Box } from "@mui/material";

export default function ProfileStats({ userData, isOwnerId }) {
  const { t } = useTranslation("common");
  const history = useHistory();

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{ gap: "16px", marginTop: "2px" }}
    >
      {/* Followers */}
      <Box
        onClick={() =>
          history.push(`/app/Follow/${userData["_id"]}`, { userData })
        }
        sx={{
          display: "flex",
          alignItems: "baseline",
          gap: "4px",
          cursor: "pointer",
          "&:hover .stat-label": { color: "#FFEE20" },
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            color: "#FFF",
          }}
        >
          {userData["followerCount"]}
        </Typography>
        <Typography
          className="stat-label"
          sx={{
            fontSize: "14px",
            color: "#888",
            transition: "color 0.2s ease",
          }}
        >
          {t("artistProfile.followers")}
        </Typography>
      </Box>

      {/* Following */}
      <Box
        onClick={() =>
          history.push(`/app/Following/${userData["_id"]}`, { userData })
        }
        sx={{
          display: "flex",
          alignItems: "baseline",
          gap: "4px",
          cursor: "pointer",
          "&:hover .stat-label": { color: "#FFEE20" },
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            color: "#FFF",
          }}
        >
          {userData["followingCount"]}
        </Typography>
        <Typography
          className="stat-label"
          sx={{
            fontSize: "14px",
            color: "#888",
            transition: "color 0.2s ease",
          }}
        >
          {t("artistProfile.following")}
        </Typography>
      </Box>
    </Stack>
  );
}
